module.exports = __webpack_public_path__ + "img/175.side_courses.80eb4487.svg";